import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import {
  cidadeClientesSchema,
  dashboardExecutiveSchema,
  hectaresRankingSchema,
  imoveisGestaoSchema,
} from './schemas';

export function useDashboardExecutive() {
  return useQuery({
    queryKey: ['dashboard', 'executive'] as const,
    queryFn: ({ signal }) =>
      api('/api/v2/dashboard/executive', {
        schema: dashboardExecutiveSchema,
        signal,
      }),
    staleTime: 2 * 60_000,
    refetchInterval: 5 * 60_000,
  });
}

export function useHectaresRanking(enabled: boolean) {
  return useQuery({
    queryKey: ['dashboard', 'hectares-ranking'] as const,
    queryFn: ({ signal }) =>
      api('/api/v2/dashboard/hectares-ranking', {
        schema: hectaresRankingSchema,
        signal,
      }),
    enabled,
    staleTime: 5 * 60_000,
  });
}

export function useImoveisPorCidade(cidade: string | null) {
  return useQuery({
    queryKey: ['dashboard', 'imoveis-por-cidade', cidade] as const,
    queryFn: ({ signal }) =>
      api(`/api/v2/dashboard/imoveis-por-cidade?cidade=${encodeURIComponent(cidade ?? '')}`, {
        schema: cidadeClientesSchema,
        signal,
      }),
    enabled: !!cidade,
    staleTime: 5 * 60_000,
  });
}

export function useImoveisSobGestao(enabled: boolean) {
  return useQuery({
    queryKey: ['dashboard', 'imoveis-sob-gestao'] as const,
    queryFn: ({ signal }) =>
      api('/api/v2/dashboard/imoveis-sob-gestao', {
        schema: imoveisGestaoSchema,
        signal,
      }),
    enabled,
    staleTime: 5 * 60_000,
  });
}
